import React from 'react';

require('./stylesheets/Filter.scss');

const { array, func, string } = React.PropTypes;

const Filter = (props) => {
  const options = props.choices.map((item, index) => {
    return (
      <option key={ index } value={ item.toLowerCase() }>{ item }</option>
    );
  });

  return (
    <div className="filter">
      <form id="filter" className="filter-form">
        <label htmlFor="filter-select" className="filter-label">Filter&nbsp;Results: </label>
        <div className="custom-select">
          <select id="filter-select" name="filter-select" className="filter-select" value={ props.selected } onChange={ props.onChange }>
            <option value="default">Select</option>
            { options }
          </select>
        </div>
      </form>
    </div>
  );
};

Filter.propTypes = {
  choices: array.isRequired,
  selected: string.isRequired,
  onChange: func.isRequired
};

export default Filter;




// WEBPACK FOOTER //
// ./app/src/Portfolio/components/Filter.js